import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import empresaService from "../../services/EmpresaService";
import { EmpresaInterface } from "../../interfaces";
import { MakeMessageError } from "../../components/Components";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faQrcode } from "@fortawesome/free-solid-svg-icons";
import ReactInputMask from "react-input-mask";
import { formatMoeda, rgx_numberOnly } from "../../utils/utils";
import { TermoUsoModal } from "../assinatura/TermoUsoModal";
import auxService from "../../services/AuxService";
import { useModalMessage } from "../../components/ModalMessage/useModalMessage";


const initialFieldsError = {
    comprador_cpfcnpj: [],
    comprador_nome: [],
}

interface Empresa extends EmpresaInterface {
    uf: string;
    municipio: string;
}

const initialState: Empresa = {
    active: false,
    name: '',
    cpfcnpj: '',
    ie: '',
    xfant: '',
    xlgr: '',
    nro: '',
    xbairro: '',
    cep: '',
    xcpl: '',
    estado_id: 0,
    municipio_id: 0,
    fone: '',
    celular: '',
    certificado: '',
    devolucao: 0,
    email: '',
    id: 0,
    imagem: '',
    isMatriz: false,
    podeDevolver: false,
    tipoEmpresa: '',
    tpamb: 0,
    uf: '',
    municipio: ''
}

export default function FormAtivacaoLicenca() {
    const navigate = useNavigate();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { id } = useParams<{ id: string }>();
    const [form, setForm] = useState<Empresa>(initialState);
    const [assinante, setAssinante] = useState({
        comprador_cpfcnpj: '',
        comprador_nome: '',

    });
    const btnGerarQrCode = useRef<HTMLButtonElement | null>(null);
    const btnVoltar = useRef<HTMLAnchorElement | null>(null);
    const [aceite, setAceite] = useState<boolean>(false);
    const [showTermo, setShowTermo] = useState<boolean>(false);
    const [assinatura, setAssinatura] = useState({
        id: 0,
        valor: 0,
        quantidade_meses_restante: 0,
        valor_anual: 0,
        valor_mensal: 0
    });
    const [errors, setErrors] = useState(initialFieldsError);

    const handleAceite = () => {
        setAceite(true);
        // setForm({ ...form, aceite: true });
        setShowTermo(false);

    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        desabilitaButtonFooter();

        auxService.postAtivarLicenca(assinante, id)
            .then(res => {
                desabilitaButtonFooter(false);
                navigate('/qrcode', {
                    state: {
                        qrcode: res.data.qrcode,
                        image: res.data.image,
                        documento: res.data.documento,
                        valor: res.data.valor,
                        tipo: 'licenca'
                    }
                });
            })
            .catch(error => {
                desabilitaButtonFooter(false);

                if (error.response) {
                    if (error.response.status === 422) {
                        setErrors(error.response.data);
                    }
                }
            })


    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: "" }));


        const transformers: Record<string, (val: string) => string> = {
            comprador_cpfcnpj: rgx_numberOnly,

        };

        const newValue = transformers[name] ? transformers[name](value) : value;

        setAssinante({ ...assinante, [name]: newValue });
    };

 const desabilitaButtonFooter = (status = true) => {

        if (status) {

            if (btnGerarQrCode.current) {
                btnGerarQrCode.current.disabled = true;
            }

            if (btnVoltar.current) {
                btnVoltar.current.style.pointerEvents = 'none';
                btnVoltar.current.style.opacity = '0.5';
                btnVoltar.current.style.cursor = 'not-allowed';
            }
        } else {

            if (btnGerarQrCode.current) {
                btnGerarQrCode.current.disabled = false;
            }

            if (btnVoltar.current) {
                btnVoltar.current.style.pointerEvents = 'auto';
                btnVoltar.current.style.opacity = '1';
                btnVoltar.current.style.cursor = 'pointer';
            }
        }
    }

    useEffect(() => {
        if (id) {
            empresaService.get(id).then(res => {
                console.log(res);
                setForm(res);
            }).catch(err => alertModal('Houve um erro ao carregar dados da empresa.', 'danger'));
        }

        auxService.getAssinaturaLicenca().then(res => {
            setAssinatura({
                id: res.id,
                valor: res.valor,
                quantidade_meses_restante: res.quantidade_meses_restante,
                valor_anual: res.valor_anual,
                valor_mensal: res.valor_mensal
            })
        })
            .catch(error => console.log(error));

    }, [id]);
    return (<>
        {showTermo && (

            <TermoUsoModal
                show={showTermo}
                aceite={aceite}
                onHide={() => setShowTermo(false)}
                handleAceite={handleAceite} />
        )}
        <Form onSubmit={handleSubmit}>
            <Card className="card-primary card-outline">
                <Card.Header className="d-flex justify-content-between">
                    {aceite && (
                        <div>
                            <Button variant="primary" type="submit" ref={btnGerarQrCode} disabled={!aceite}>
                                <FontAwesomeIcon icon={faQrcode} /> Gerar pagamento
                            </Button>
                        </div>
                    )}

                    <div>
                        {!aceite && (
                            <Button variant="success" onClick={() => setShowTermo(true)}>Aceitar termos</Button>
                        )}
                    </div>
                    <div>
                        <Link to="/empresa" className="btn btn-secondary me-2" ref={btnVoltar}>
                            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                        </Link>
                    </div>

                </Card.Header>

                <Card.Body>
                    <fieldset className="group-box">
                        <legend>Dados do comprador</legend>

                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-2" controlId="comprador_nome">
                                    <Form.Label>* Nome</Form.Label>
                                    <Form.Control type="text" maxLength={60} autoFocus
                                        onChange={handleChange}
                                        value={assinante.comprador_nome}
                                        name="comprador_nome" />
                                    <MakeMessageError errors={errors} field="comprador_nome" />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-2" controlId="comprador_cpfcnpj">
                                    <Form.Label>* CPF/CNPJ</Form.Label>
                                    <Form.Control type="text" maxLength={14}
                                        onChange={handleChange}
                                        value={assinante.comprador_cpfcnpj}
                                        name="comprador_cpfcnpj" />
                                    <MakeMessageError errors={errors} field="comprador_cpfcnpj" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-2 text-end" controlId="valor">
                                    <Form.Label >Valor Proporcional</Form.Label>
                                    <Form.Control type="text" disabled className="text-end"
                                        value={formatMoeda(assinatura.valor)}
                                        name="valor" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </fieldset>
                    <fieldset className="group-box">
                        <legend>Dados da filial</legend>
                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-2" controlId="name">
                                    <Form.Label>Nome da razão social:</Form.Label>
                                    <Form.Control type="text" name="name" disabled
                                        value={form.name}
                                        maxLength={60}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group className="mb-2" controlId="xfant">
                                    <Form.Label>Nome fantasia:</Form.Label>
                                    <Form.Control type="text" name="xfant" disabled
                                        value={form.xfant}
                                        maxLength={60}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-2" controlId="cpfcnpj">
                                    <Form.Label>CNPJ:</Form.Label>
                                    <Form.Control type="text" name="cpfcnpj" disabled
                                        value={form.cpfcnpj}
                                        maxLength={14}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-2" controlId="ie">
                                    <Form.Label>Inscrição Estadual:</Form.Label>
                                    <Form.Control type="text" name="ie" disabled
                                        value={form.ie}
                                        maxLength={14}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-2" controlId="xlgr">
                                    <Form.Label>Endereço:</Form.Label>
                                    <Form.Control type="text" name="xlgr" disabled
                                        value={form.xlgr}
                                        maxLength={60}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-2" controlId="nro">
                                    <Form.Label>Número:</Form.Label>
                                    <Form.Control type="text" name="nro" disabled
                                        value={form.nro}
                                        maxLength={60}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-2" controlId="cep">
                                    <Form.Label>CEP:</Form.Label>
                                    <Form.Control type="text" name="cep" disabled
                                        value={form.cep}
                                        maxLength={8}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="g-2">

                            <Col md>
                                <Form.Group className="mb-2" controlId="xcpl">
                                    <Form.Label>Complemento:</Form.Label>
                                    <Form.Control type="text" name="xcpl" disabled
                                        value={form.xcpl}
                                        maxLength={60}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-2" controlId="xbairro">
                                    <Form.Label>Bairro:</Form.Label>
                                    <Form.Control type="text" name="xbairro" disabled
                                        value={form.xbairro}
                                        maxLength={60}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-2" controlId="fone">
                                    <Form.Label>Telefone:</Form.Label>
                                    <ReactInputMask mask="(99)9999-9999" name="fone" disabled
                                        className="form-control"
                                        value={form.fone}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-2" controlId="celular">
                                    <Form.Label>Celular:</Form.Label>
                                    <ReactInputMask mask="(99)99999-9999"
                                        name="celular" className="form-control"
                                        value={form.celular} disabled
                                    />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className="g-2">
                            <Col md={2}>
                                <Form.Group className="mb-2" controlId="estado_id">
                                    <Form.Label>UF</Form.Label>
                                    <Form.Control type="text" name="uf"
                                        value={form.uf}
                                        maxLength={60}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-2" controlId="municipio_id">
                                    <Form.Label>Municípios</Form.Label>
                                    <Form.Control type="text" name="municipio"
                                        value={form.municipio}
                                        maxLength={60}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                    </fieldset>
                    <fieldset className="group-box" style={{ marginBottom: '0' }}>
                        <legend>Preços:</legend>
                        <p className="lh-1">
                            <strong className="lh-1">Valor Anual: </strong>
                            <span className="text-primary fw-bold lh-1">{formatMoeda(assinatura.valor_anual)}</span>
                            , cobrado na próxima renovação somado a licença principal da matriz e a outras filiais
                            se houver.
                        </p>
                        <p className="lh-1"><strong>(A): Valor mensal: </strong>
                            <span className="text-primary fw-bold">{formatMoeda(assinatura.valor_mensal)}</span>
                        </p>
                        <p className="lh-1"><strong>(B): Quantidade de meses para a proxima renovação: </strong>
                            <span className="text-primary fw-bold">{assinatura.quantidade_meses_restante}</span>
                        </p>
                        <p className="lh-2"><strong>Valor proporcional: </strong>
                            <span className="text-primary fw-bold">{formatMoeda(assinatura.valor)}</span>
                            . Equivale ao <strong>(A)</strong>Valor mensal <strong>(B)</strong>
                            Quantidade de meses que falta para a próxima renovação. Valor proporcional
                            mínimo <strong className="text-primary fw-bold">{formatMoeda(assinatura.valor_mensal)}</strong>.
                        </p>

                    </fieldset>
                </Card.Body>

            </Card>
        </Form>
        {ModalMessageEl}
    </>);

}